import { render, staticRenderFns } from "./KaiFormTextArea.vue?vue&type=template&id=631fb03f&scoped=true&"
import script from "./KaiFormTextArea.vue?vue&type=script&lang=ts&"
export * from "./KaiFormTextArea.vue?vue&type=script&lang=ts&"
import style0 from "./KaiFormTextArea.vue?vue&type=style&index=0&id=631fb03f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631fb03f",
  null
  
)

export default component.exports